/** Shimmering placeholder block. Use while data loads instead of a "Loading…" line. */
export function Skeleton({ lines = 3, className = "" }: { lines?: number; className?: string }) {
  return (
    <div className={`skeleton ${className}`.trim()} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <span key={i} className="skeleton-line" />
      ))}
    </div>
  );
}
